import { render } from "./RatingTimeline.vue?vue&type=template&id=57b5f062"
import script from "./RatingTimeline.vue?vue&type=script&lang=js"
export * from "./RatingTimeline.vue?vue&type=script&lang=js"

import exportComponent from "/home/gaspa/Projects/coffee-jurnal/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__